import React, { useCallback } from "react";
import { CounterpartyCreationResponse } from "@common/contracts/counterparty.contract";
import { CounterpartyVerifiedToast } from "@components/counterparty/CounterpartyVerifiedToast/CounterpartyVerifiedToast";
import { useToaster } from "@design-system/ToastMessages/useToaster";

interface UseCounterpartyVerifiedToastOptions {
    forTransactionEditing?: boolean;
}

export function useCounterpartyVerifiedToast({
    forTransactionEditing,
}: UseCounterpartyVerifiedToastOptions = {}) {
    const { toast } = useToaster();

    return useCallback(
        (creationResponse: CounterpartyCreationResponse) => {
            if (
                creationResponse.revealedOnTransactionsNumber &&
                (forTransactionEditing ||
                    creationResponse.revealedOnTransactionsNumber > 1)
            ) {
                toast(
                    <CounterpartyVerifiedToast
                        counterparty={creationResponse.counterparty}
                        transactionsNumber={
                            creationResponse.revealedOnTransactionsNumber
                        }
                    />,
                    `counterparty-verified-${creationResponse.counterparty.id}`,
                );
            }
        },
        [forTransactionEditing, toast],
    );
}
